import React, {Component} from 'react';

import conjectTypes from './conject_types.json';

class ConjuctTypes extends Component {

    componentDidMount () {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div className="component-wrapper">
                <div className='list-table-title'>
                    <h1>Geographic Feature Types</h1>
                </div>
                <div className='list-table'>
                    <table>
                        <thead>
                            <tr>
                                <th>DSG Code</th>
                                <th>Type</th>
                                <th>Description</th>
                                <th>Class</th>
                            </tr>
                        </thead>
                        <tbody>
                        {conjectTypes.map((conjuctType) =>
                            <tr key={conjuctType.DSGCode}>
                                <td>{conjuctType.DSGCode}</td>
                                <td>{conjuctType.type}</td>
                                <td>{conjuctType.description}</td>
                                <td>{conjuctType.classCode}</td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
};

export default ConjuctTypes;